import PropTypes from 'prop-types';

function IFSnacksActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M3.93233 12.8444L21.5431 7.16281C21.0824 2.20682 3.9033 9.9238 3.43165 11.3388C3.36618 11.8816 3.42957 12.4322 3.61668 12.946L3.93233 12.8444Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.6506 10.3956C4.10276 8.17161 5.66285 5.63557 9.05875 8.29497C12.4547 10.9544 9.5304 13.5086 9.5304 13.5086L6.30502 13.4251C6.30502 13.4251 4.85378 11.2337 4.6506 10.3956Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M6.36672 8.83936C4.8538 7.13415 4.52364 4.33326 8.81569 4.60536C13.1077 4.87747 13.5613 9.74639 13.5613 9.74639L9.90049 11.7418C9.90049 11.7418 7.12862 9.69196 6.36672 8.83936Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.189 9.88042C12.3749 8.48723 12.0121 5.20742 15.5677 3.34983C19.3772 1.35438 19.5586 7.80514 19.5586 7.80514L17.5994 10.3448L14.189 9.88042Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M12.2334 10.432C10.9817 8.51269 10.7205 4.6669 15.0125 4.939C19.3046 5.21111 18.0057 10.2433 18.0057 10.2433L15.3137 11.9993L12.2334 10.432Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M7.41528 13.1129C6.87107 10.8852 7.90145 7.17007 11.8597 8.84988C15.818 10.5297 12.9227 14.8508 12.9227 14.8508L9.79895 15.6127L7.41528 13.1129Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.4937 12.4494C13.2421 10.5301 13.9713 7.312 17.9622 6.73151C22.218 6.11836 20.2661 12.2607 20.2661 12.2607L17.574 14.0167L14.4937 12.4494Z"
                fill="#F6A685"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M3.61664 12.9463C4.34273 15.0846 5.63253 16.9874 7.34996 18.4537C10.6842 21.3562 9.30913 27.9231 11.3409 28.8555C13.3726 29.7879 30.178 26.5916 27.3698 20.5508C25.1277 15.7182 21.9785 12.1227 21.5431 7.16309L3.61664 12.9463Z"
                fill="#63ACDE"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M3.61664 12.9463L21.5431 7.16309C21.6086 7.77281 21.708 8.37842 21.8406 8.97714L4.16811 14.3286L3.61664 12.9463Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.0643 15.3554C12.1319 16.8683 10.1183 20.9934 14.6135 22.8075C19.1088 24.6215 21.2784 20.9572 21.5069 19.4152C21.75 17.5794 21.2856 15.3445 19.6929 14.4302C18.1002 13.5159 14.4031 13.1821 13.0643 15.3554Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.7784 22.7529L11.9866 27.6545L18.3503 25.913C18.3503 25.913 14.4174 25.5502 13.3181 25.1475C12.9771 25.0169 10.7784 22.7529 10.7784 22.7529Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.207 18.345C14.2904 17.9169 14.8999 15.5332 16.8954 15.9432C18.8909 16.3532 19.5149 17.1949 19.8995 17.9967"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.0221 20.1589C14.3486 20.6233 17.3273 23.1412 19.6674 20.0029"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IFSnacksActive;

IFSnacksActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFSnacksActive.defaultProps = {
    className: null,
    width: 28,
};
